<template>
  <vx-card
    class="mt-base"
    title="Physiotherapy Activity 3: The Differences Between Physiotherapists, Chiropractors, and Osteopaths"
  >
    <p class="mb-5">
      There are more similarities between chiropractors, osteopaths and physiotherapists than there
      are differences, and they are all trained in helping with aches and pains.
    </p>
    <p class="mb-5">
      The differences between osteopaths, chiropractors, and physiotherapists can be difficult to
      differentiate as they are all drug-free manual therapies that seem to treat similar areas of
      the body.
    </p>
    <p class="mb-5">
      Remember this video from your learning and resources? Use it to answer the below multiple
      choice quiz.
    </p>
    <responsive-youtube-wrapper :video="videos[1].video" :image="videos[1].image" class="mb-0" />

    <div v-for="(question, index) in questions" :key="'q1_' + index">
      <h5 class="mb-5 questionlabel">{{ question.question }}</h5>
      <radio-buttons-wrapper
        v-model="data['question_' + index]"
        :index="'q1_' + index"
        :question="question"
        :is-editable="isEditable"
        show-question="false"
      />
    </div>

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import RadioButtonsWrapper from '../../components/ActivitiesBlocks/RadioButtonsWrapper';

export default {
  data() {
    return {
      videos: {
        1: {
          video: 'https://www.youtube.com/embed/OqdcfWESmWg',
          image: require('@/assets/images/experiences/physiotherapy/physio_chiro_osteo_splash.jpg'),
        },
      },

      questions: {
        1: {
          question:
            '1. Which profession often involves the specific manipulation of the spine to reduce pain and increase mobility?',
          answers: [
            {
              val: 1,
              answer: 'a. Physiotherapy',
              correct: false,
            },
            {
              val: 2,
              answer: 'b. Chiropractic',
              correct: true,
            },
            {
              val: 3,
              answer: 'c. Osteopathy',
              correct: false,
            },
          ],
        },
        2: {
          question:
            '2. Which profession utilises the body’s natural ability to maintain itself to restore normal function?',
          answers: [
            {
              val: 1,
              answer: 'a. Physiotherapy',
              correct: false,
            },
            {
              val: 2,
              answer: 'b. Chiropractic',
              correct: false,
            },
            {
              val: 3,
              answer: 'c. Osteopathy',
              correct: true,
            },
          ],
        },
        3: {
          question:
            '3. Which profession is science-based and has the patient’s involvement in their own care at its core?',
          answers: [
            {
              val: 1,
              answer: 'a. Physiotherapy',
              correct: true,
            },
            {
              val: 2,
              answer: 'b. Chiropractic',
              correct: false,
            },
            {
              val: 3,
              answer: 'c. Osteopathy',
              correct: false,
            },
          ],
        },
      },
    };
  },
  methods: {
    ...methods,
  },
  computed: {
    ...computed,
  },
  inject: inject,
  components: { RadioButtonsWrapper },
};
</script>
